/// <amd-module name="Release/Commands/Dialogs/DeleteFolderDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { TextField } from "VSSUI/TextField";
import { css } from "VSSUI/Util";

import { VssComponent, IVssComponentProperties, IVssComponentContext, IVssLayoutManager, Components } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";

import * as Resources from "Release/Commands/Dialogs/Resources";
import { format } from "VSS/Core/Util/String";

interface IDeleteFolderDialogProps extends IVssComponentProperties {
    folderPath: string;
}

interface IDeleteFolderDialogState {
    signature: string;
}

class DeleteFolderDialog extends VssComponent<IDeleteFolderDialogProps, IDeleteFolderDialogState>{
    public render(): React.ReactNode {
        const state = this.state || { signature: "" };
        const displayFolderPath = this.props.folderPath.substring(1);
        const folderName = this.props.folderPath.substring(this.props.folderPath.lastIndexOf("\\") + 1);
        const lowerCaseSignature = state.signature.toLowerCase();
        const lowerCaseFolderPath = this.props.folderPath.toLowerCase();

        // Give the user the benefit of not adding the leading \
        const disableOk = !(state.signature && (lowerCaseSignature === lowerCaseFolderPath || lowerCaseFolderPath.substring(1) === lowerCaseSignature));
        return <Dialog
            titleProps={{ text: format(Resources.DeleteFolderDialogTitle, displayFolderPath) }}
            onDismiss={this._onDialogClose}
            defaultActiveElement=".delete-folder-signature"
            calloutContentClassName={css("release-command-dialog", this.props.className)}
            footerButtonProps={[
                {
                    onClick: this._onDialogClose,
                    text: Resources.Cancel
                },
                {
                    onClick: this._onOkClicked,
                    disabled: disableOk,
                    primary: true,
                    text: Resources.Ok
                }
            ]}>

            <div>
                <div className={"delete-folder-text"}>
                    {format(Resources.DeleteFolderDialogContent, displayFolderPath)}
                </div>
                <br />
                <TextField
                    label={Resources.DeleteFolderTextboxLabel}
                    value={state.signature}
                    inputClassName={"delete-folder-signature"}
                    onChange={this._onSignatureChanged} />
            </div>
        </Dialog>;
    }

    private _closeDialog() {
        if (!!this.props.onClose) {
            this.props.onClose();
        }
    }

    private _onDialogClose = (): void => {
        this._closeDialog();
    }

    private _onOkClicked = (): void => {
        if (!!this.props.onOkClick) {
            this.props.onOkClick();
        }
        this._closeDialog();
    }

    private _onSignatureChanged = (event: React.ChangeEvent<HTMLInputElement>, text: string) => {
        this.setState({
            signature: text
        });
    }
}

Components.add("rel-delete-folder-dialog", DeleteFolderDialog);
